import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { configuratorStore } from './configurator';
// import { designStore } from './design';
import { dropZoneStore } from './dropzones';
import { mediaStore } from './media';
import { promoStore } from './promo';
import { groupedPromoStore } from './groupedPromo';
import { compatibilityStore } from './compatibility';
import { dimensionsStore } from './dimensions';
import { digitalDataStore } from './analytics';
import { productInfoStore } from './productInfo';
import { productDataStore } from './productData';
import { collectionStore } from './collection';
import { cabinetVisualizerStore } from './cabinetVisualizer/index';
import { cabinetVisualizerDigitalDataStore } from './cabinetVisualizer/analytics';
import { vehicleStorageStore } from './vehicleStorage';
import { sandboxStore } from './sandbox';
import { devToolsEnabled } from '../utils/state-utils';

// devtools is called to enable the zustand data to show in the Redux DevTools browser extension
// disable devTools via config service / custom request headers
// defaults to false for everything especially prod

export const useConfiguratorStore = create(
  devtools(configuratorStore, { enabled: devToolsEnabled, store: 'CONFIGURATOR', name: '[DESIGNER] CONFIGURATOR' })
);

export const useDimensionsStore = create(
  devtools(dimensionsStore, { enabled: devToolsEnabled, store: 'DIMENSIONS', name: '[DESIGNER] DIMENSIONS' })
);

export const useDropZoneStore = create(
  devtools(dropZoneStore, { enabled: devToolsEnabled, store: 'DROPZONE', name: '[DESIGNER] DROPZONE' })
);

export const useMediaStore = create(
  devtools(mediaStore, { enabled: devToolsEnabled, store: 'MEDIA', name: '[DESIGNER] MEDIA' })
);

export const usePromoStore = create(
  devtools(promoStore, { enabled: devToolsEnabled, store: 'PROMO', name: '[DESIGNER] PROMO' })
);

export const useGroupedPromoStore = create(
  devtools(groupedPromoStore, { enabled: devToolsEnabled, store: 'GROUPED_PROMO', name: '[DESIGNER] GROUPED_PROMO' })
);

export const useCompatibilityStore = create(
  devtools(compatibilityStore, { enabled: devToolsEnabled, store: 'COMPATIBILITY', name: '[DESIGNER] COMPATIBILITY' })
);

export const useDigitalDataStore = create(
  devtools(digitalDataStore, { enabled: devToolsEnabled, store: 'DIGITAL DATA', name: '[DESIGNER] DIGITAL DATA' })
);

export const useProductInfoStore = create(
  devtools(productInfoStore, { enabled: devToolsEnabled, store: 'PRODUCT INFO', name: '[DESIGNER] PRODUCT INFO' })
);

export const useProductDataStore = create(
  devtools(productDataStore, { enabled: devToolsEnabled, store: 'PRODUCT DATA', name: '[DESIGNER] PRODUCT DATA' })
);

export const useCollectionStore = create(
  devtools(collectionStore, { enabled: devToolsEnabled, store: 'COLLECTION', name: '[DESIGNER] COLLECTION' })
);

export const useCabinetVisualizerStore = create(
  devtools(cabinetVisualizerStore, {
    enabled: devToolsEnabled,
    store: 'CABINET_VISUALIZER',
    name: '[DESIGNER] CABINET VISUALIZER'
  })
);

export const useVehicleStorageStore = create(
  devtools(vehicleStorageStore, {
    enabled: devToolsEnabled,
    store: 'VEHICLE_STORAGE',
    name: '[DESIGNER] VEHICLE STORAGE'
  })
);

export const useSandboxStore = create(
  devtools(sandboxStore, {
    enabled: devToolsEnabled,
    store: 'SANDBOX',
    name: '[SANDBOX] MOD STORAGE'
  })
);

export const useCabinetVisualizerDigitalDataStore = create(
  devtools(cabinetVisualizerDigitalDataStore, {
    enabled: devToolsEnabled,
    store: 'CABINET_VISUALIZER_DIGITAL_DATA',
    name: '[DESIGNER] CABINET VISUALIZER DIGITAL DATA'
  })
);
